import { render, staticRenderFns } from "./ContactHelpCenter.vue?vue&type=template&id=10022740&scoped=true&"
import script from "./ContactHelpCenter.vue?vue&type=script&lang=js&"
export * from "./ContactHelpCenter.vue?vue&type=script&lang=js&"
import style0 from "./ContactHelpCenter.vue?vue&type=style&index=0&id=10022740&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10022740",
  null
  
)

export default component.exports